/**
 * Google/Microsoft OAuth may reject custom localhost subdomains (e.g. ebs.localhost).
 * For local development normalize redirect origin to localhost.
 */
export const getSocialAuthRedirectOrigin = (
  origin = window.location.origin
): string => {
  const url = new URL(origin)

  if (url.hostname.endsWith('.localhost')) {
    url.hostname = 'localhost'
  }

  return url.origin
}

export const getSameOriginPathFromUrl = (
  targetUrl?: string | null,
  origin = window.location.origin
): string | null => {
  if (!targetUrl) return null

  try {
    const parsed = new URL(targetUrl)
    if (parsed.origin !== origin) return null
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }
}
